export enum MembershipRole {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  AI_SUPERVISOR = "AI_SUPERVISOR",
}
